export function getFormattedEntries(entries) {
  return entries.map(form => ({
    ...form,
    fields: form.fields.map(field => ({
      ...field,
      ...(field.elementOptions
        ? {
            elementOptions: field.elementOptions.map(option => ({
              ...option,
              name: option.value,
            })),
          }
        : {}),
    })),
  }));
}
